import React, { useState, useEffect, useContext, useMemo } from 'react';
import SimpleTable from '../../../components/tables/simpleTable';
import SearchFilter from '../../../components/filters/search';
import DatePicker from '../../../components/filters/datePicker';
import Loader from '../../../components/loader/loader';
import { numberFormatter, trailBalanceFormatter } from '../../../components/formatters/numberFormatter';
import toast from 'react-hot-toast';
import { FiRotateCcw, FiPrinter, FiFilter } from "react-icons/fi";
import { Space, Input, Tag, Button, Spin, Modal, Checkbox } from 'antd';
import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';
import TrialBalanceReport from './TrialBalanceReport';
import { DataContext } from '../../../init/getData';




function TrialBalance(props) {

  let { type, isDebit } = props;

  const { api, userData, settingData, refData, yearId, companyId, secondaryCurrency, mainCurrency, selectedYear, contentLanguages } = useContext(DataContext);
  const userRole = userData.role;
  const [loadingCounter, setLoadingCounter] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [isSpinning, setIsSpinning] = useState(false);
  const [data, setData] = useState([]);
  const [currency, setCurrency] = useState('main');
  const createdBy = parseInt(userData.id);

  const table = 'trialBalance';
  const title = 'TrialBalance';

  useEffect(() => {
    const fetchData = async () => {
      try {
        const dataArray = ['parentAccount']
        await refData(dataArray, companyId);
        setIsLoading(false);
      } catch (error) {
        console.error('Error refreshing data Contact Support');
      }
    };
    fetchData();
  }, []);


  const fromDate = selectedYear?.year + '-01-01';
  const toDate = selectedYear?.year + '-12-31';


  const [idRow, setIdRow] = useState([]);
  const [refreshTable, setRefreshTable] = useState(true);
  const [columnDefs, setColumnDefs] = useState([]);
  const [filter, setFilter] = useState({ search: '', companyId, yearId, fromDate: fromDate, toDate: toDate, parentId: null });

  const [showReportModal, setShowReportModal] = useState(false);

    // Add this function to handle the report modal
    const reportModal = () => {
      setShowReportModal(!showReportModal);
    };

  

  //change Type
  useEffect(() => {
    setFilter(prevFilter => ({ ...prevFilter, type: type }));
  }, [type]);

  const [showAddModal, setShowAddModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showRecoverModal, setShowRecoverModal] = useState(false);
  const [showModal, setShowModal] = useState(false);


  const refreshTableFunction = () => {
    setRefreshTable(!refreshTable)
  }

  //Excel Data
  const getExcelData = (data) => {

    const transformedData = [];
    data.forEach(item => {

      const newItem = {
        ID: item.parentId ? `${item.parent?.accountId}.${item.accountId}` : item.accountId,
        Type: item.type,
        Name: item.english,
        "Opening Debit": isMainCurrency ? item.totalDebitOpening : item.secondaryTotalDebitOpening,
        "Opening Credit": isMainCurrency ? item.totalCreditOpening : item.secondaryTotalCreditOpening,
        Debit: isMainCurrency ? item.totalDebitNormal : item.secondaryTotalDebitNormal,
        Credit: isMainCurrency ? item.totalCreditNormal : item.secondaryTotalCreditNormal,
        Balance: isMainCurrency ? item.balance : item.secondaryBalance,
      };

      transformedData.push(newItem);
    });

    return { transformedData };
  };

  const accountIdView = (id, record) => {
    if (record.parentId && record.isAux) {
      return <>{record.parent?.accountId + '.' + record.accountId}</>
    } else {
      return <>{record.accountId}</>
    }
  }

  const isMainCurrency = currency == 'main' ? true : false;

  const newColumnDefs = useMemo(() => [
    { title: contentLanguages.ID, dataIndex: 'parentId', width: '10%', sorter: (a, b) => a.age - b.age, render: accountIdView },
    { title: contentLanguages.Type, dataIndex: 'type', width: '10%' },
    { title: contentLanguages.Name, dataIndex: 'english', width: '20%' },
    { title: contentLanguages.OpeningDebit, dataIndex: isMainCurrency ? 'totalDebitOpening' : 'secondaryTotalDebitOpening', width: '10%', render: numberFormatter },
    { title: contentLanguages.OpeningCredit, dataIndex: isMainCurrency ? 'totalCreditOpening' : 'secondaryTotalCreditOpening', width: '12%', render: numberFormatter },
    { title: contentLanguages.Debit, dataIndex: isMainCurrency ? 'totalDebitNormal' : 'secondaryTotalDebitNormal', width: '8%', render: numberFormatter },
    { title: contentLanguages.Credit, dataIndex: isMainCurrency ? 'totalCreditNormal' : 'secondaryTotalCreditNormal', width: '12%', render: numberFormatter },
    { title: contentLanguages.Balance, dataIndex: isMainCurrency ? 'balance' : 'secondaryBalance', render: trailBalanceFormatter },
  ]);



  const tableFooter = useMemo(() => [
    <div style={{ textAlign: 'center', paddingRight: '120px' }}>
      <Tag color={'#2c5d6f'} style={{ fontSize: '15px' }}>
        <div style={{ padding: '2px' }}>
          {contentLanguages.TotalDebit}: {numberFormatter(isMainCurrency ? data?.sumTotalDebit : data?.secondarySumTotalDebit)}
        </div>
      </Tag>
      <Tag color={'#2c5d6f'} style={{ fontSize: '15px' }}>
        <div style={{ padding: '2px' }}>
          {contentLanguages.TotalCredit}: {numberFormatter(isMainCurrency ? data?.sumTotalCredit : data?.secondarySumTotalCredit)}
        </div>
      </Tag>
    </div>
  ]);



  const onCheckChange = (e) => {
    const name = e.target.name;
    const checked = e.target.checked;
    setFilter((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  return (
    <div>

      {isLoading &&
        <Loader />
      }


      {!isLoading &&
        <div>

          <Row className='g-2 mb-3'>

            <Col md={2}>
              <SearchFilter setFilter={setFilter} />
            </Col>

            <Col md={3}>
              <DatePicker setFilter={setFilter} filter={filter} />
            </Col>

            <Col md={1}>
              <Form.Select size="sm" onChange={e => setCurrency(e.target.value)} value={currency}>
                <option value={'main'}>{mainCurrency.code}</option>
                <option value={'secondary'}>{secondaryCurrency.code}</option>
              </Form.Select>
            </Col>



            <Col md={4}>
              <Button onClick={refreshTableFunction} style={{ backgroundColor: '#22566a' }}>
                <FiFilter size={18} color='white' />
              </Button>
            </Col>


            <Col md={2} className="d-flex justify-content-end">
              <Button onClick={reportModal} style={{ marginRight: '8px' }}>
                <FiPrinter size={18} />
              </Button>
              <Button onClick={refreshTableFunction}>
                <FiRotateCcw size={18} />
              </Button>
            </Col>

          </Row>



          <SimpleTable
            filter={filter}
            table={table}
            title={title}
            columnDefs={newColumnDefs}
            idRow={idRow}
            setIdRow={setIdRow}
            refreshTable={refreshTable}
            data={data}
            setData={setData}
            tableFooter={tableFooter}
            api={api}
            getExcelData={getExcelData}
            selection={true}
            height={true}
          />

          {showReportModal && (
            <TrialBalanceReport
              showModal={showReportModal}
              toggleModal={reportModal}
              filter={filter}
              currency={currency}
              mainCurrency={mainCurrency}
              secondaryCurrency={secondaryCurrency}
              data={data}
            />
          )}





        </div>
      }


    </div>
  )
}

export default TrialBalance;
